import { ToggleGroup, ToggleGroupItem } from "@/components/shadcn/toggle-group";
import type { MailDirectionFilter } from "../types";

const OPTIONS: { value: MailDirectionFilter; label: string }[] = [
  { value: "all", label: "All" },
  { value: "inbound", label: "Received" },
  { value: "outbound", label: "Sent" },
];

type MailDirectionToggleProps = {
  value: MailDirectionFilter;
  onChange: (value: MailDirectionFilter) => void;
};

/** Splits the list the way a mail client's folders do. */
export const MailDirectionToggle = ({ value, onChange }: MailDirectionToggleProps) => (
  <ToggleGroup
    type="single"
    value={value}
    // Radix reports an empty value when the active item is clicked again; keep the selection.
    onValueChange={next => next && onChange(next as MailDirectionFilter)}
    aria-label="Show emails"
    className="grid w-full grid-cols-3 gap-1 rounded-md bg-gray-100 p-1"
  >
    {OPTIONS.map(option => (
      <ToggleGroupItem
        key={option.value}
        value={option.value}
        size="sm"
        className="h-7 text-xs hover:bg-kPurple-50 hover:text-kPurple-500 data-[state=on]:bg-kPurple-500 data-[state=on]:text-white data-[state=on]:shadow-sm"
      >
        {option.label}
      </ToggleGroupItem>
    ))}
  </ToggleGroup>
);
